import { Flex, Text } from '@qga/roo-ui/components';

import PriceContainer from '../PriceContainer';

export type EnterDatesForPricingProps = {
  reason: string;
};

const EnterDatesForPricing = ({ reason }: EnterDatesForPricingProps) => {
  return (
    <PriceContainer borderColor="orange">
      <Flex flexDirection="column">
        <Text fontWeight="bold" color="orange">
          Enter dates for pricing
        </Text>
        <Text fontSize="sm" color="greys.steel">
          {reason}
        </Text>
      </Flex>
    </PriceContainer>
  );
};

export default EnterDatesForPricing;
